export const Divider = () => (
  <hr className="notion-divider border-t border-gray-300 dark:border-gray-600 my-5" />
);
